import React from "react";
import { Dialog, DialogContent } from "./ui/dialog";
import { ArrowUpRight, MapPin, Clock, CalendarDays, X } from "lucide-react";
import { fullDate, timeRange } from "../lib/date";

export const EventDetailModal = ({ event, open, onClose }) => {
  if (!event) return null;
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent
        data-testid="event-detail-modal"
        className="max-w-2xl p-0 gap-0 bg-paper border-ink/10 overflow-hidden max-h-[90vh] overflow-y-auto"
      >
        <button
          onClick={onClose}
          data-testid="event-modal-close"
          aria-label="Close"
          className="absolute right-4 top-4 z-10 p-2 rounded-full bg-paper/80 backdrop-blur text-ink hover:bg-paper"
        >
          <X size={18} />
        </button>

        {event.image_url ? (
          <div className="relative aspect-[16/9] overflow-hidden">
            <img src={event.image_url} alt={event.title} className="w-full h-full object-cover grayscale-img" />
            <div className="absolute inset-0 bg-ink/15" />
          </div>
        ) : (
          <div className="aspect-[16/9] bg-ink flex items-center justify-center">
            <span className="font-serif text-paper/30 text-6xl italic">TT</span>
          </div>
        )}

        <div className="p-7 md:p-10">
          <span className="font-sans text-[11px] tracking-[0.18em] uppercase text-trailride font-semibold">
            {event.category}
          </span>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-ink mt-3 leading-tight">
            {event.title}
          </h2>

          <div className="font-sans text-sm text-ink/70 space-y-2 mt-6">
            <p className="flex items-center gap-3">
              <CalendarDays size={16} className="text-trailride shrink-0" /> {fullDate(event.start)}
            </p>
            <p className="flex items-center gap-3">
              <Clock size={16} className="text-trailride shrink-0" /> {timeRange(event.start, event.end)}
            </p>
            <p className="flex items-center gap-3">
              <MapPin size={16} className="text-trailride shrink-0" /> {event.location}
            </p>
          </div>

          <p className="font-sans text-base text-ink/80 leading-relaxed mt-6 whitespace-pre-line">
            {event.description}
          </p>

          {event.tigerlink_url && (
            <a
              href={event.tigerlink_url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="event-modal-rsvp"
              className="inline-flex items-center justify-center gap-2 mt-8 px-8 py-4 rounded-full bg-trailride text-white font-sans font-medium hover:bg-trailride-dark hover:-translate-y-0.5 transition-all duration-300"
            >
              RSVP on TigerLink <ArrowUpRight size={18} />
            </a>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
